import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and Anon Key must be provided');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// リフレッシュトークンエラー時にローカルセッションを自動クリア
const clearLocalSession = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('sb-')) localStorage.removeItem(key);
  });
};

supabase.auth.onAuthStateChange((event, session) => {
  if (
    event === 'TOKEN_REFRESHED' && !session ||
    (event as string) === 'TOKEN_REFRESH_FAILED'
  ) {
    clearLocalSession();
  }
});

// グローバルなリフレッシュトークンエラーをキャッチしてセッションをクリア
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  try {
    const response = await originalFetch(...args);
    return response;
  } catch (err) {
    throw err;
  }
};

// Supabaseの内部エラーをグローバルにキャッチ
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  if (
    error?.message?.includes('Refresh Token Not Found') ||
    error?.message?.includes('Invalid Refresh Token') ||
    error?.name === 'AuthApiError'
  ) {
    clearLocalSession();
    supabase.auth.signOut({ scope: 'local' }).catch(() => {});
    event.preventDefault();
  }
});

export interface DiaryEntry {
  id: string;
  title: string;
  subject: string;
  content: string;
  study_hours: number;
  created_at: string;
  updated_at: string;
}

export interface StudyMaterial {
  id: string;
  title: string;
  subject: string;
  description: string;
  file_url: string | null;
  file_type: string | null;
  created_at: string;
  updated_at: string;
}

export interface LectureVideo {
  id: string;
  title: string;
  subject: string;
  series: string | null;
  youtube_url: string;
  youtube_id: string;
  description: string | null;
  duration: string | null;
  created_at: string;
  updated_at: string;
}

export interface GroupSchedule {
  id: string;
  group_id: string;
  calendar_name: string;
  created_by: string | null;
  created_at: string;
}

export interface GroupScheduleSlot {
  id: string;
  schedule_id: string;
  group_id: string;
  title: string;
  start_datetime: string;
  end_datetime: string;
  created_by: string | null;
  color: string;
  created_at: string;
}